<template>
    <form @submit.prevent="$emit('submit')" @keyup="$emit('keyup')" autocomplete="new-password">
        <Spinner v-if="loading" />
        <slot v-else />
    </form>
</template>

<script>
    import Spinner from '../Loaders/Spinner'

    export default {
        name: 'Form',
        props: {
            loading: Boolean
        },
        components: {
            Spinner
        }
    }
</script>